import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// This hook will tell you if you are using a mobile screen size
const useIsMobile = () => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down('md'));
};

export default useIsMobile;
